import type { IMetaArchives } from '~/types/api/archives';
import type { TArticle } from '~/types/common';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';

export const useArchivesStore = wrapPiniaStore(
  defineStore('archives', {
    state: () => ({
      articles: [] as TArticle[],
      meta: null as IMetaArchives | null,
    }),

    actions: {
      setArticles(articles: TArticle[]) {
        this.articles = articles;
      },

      setMeta(meta: IMetaArchives) {
        this.meta = meta;
      },
    },
  }),
);
